import { render, staticRenderFns } from "./TrendingSearchQueries.vue?vue&type=template&id=3ea18070&scoped=true&"
import script from "./TrendingSearchQueries.vue?vue&type=script&lang=js&"
export * from "./TrendingSearchQueries.vue?vue&type=script&lang=js&"
import style0 from "./TrendingSearchQueries.vue?vue&type=style&index=0&id=3ea18070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea18070",
  null
  
)

export default component.exports